<template>
    <div>
        <div class="box-body">
            <div v-for="(values,type) in payments">
                {{type|translate}}
                <ul v-for="value in values">
                    <li>
                        {{"amount"| translate}}: {{value.qb_received_amount}} <br/>
                        {{"booking_date"|translate}}: {{value.booking_date}} <br/>
                        {{"creation_date"|translate}}: {{value.qb_received_at}}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ["payments"]
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tools/PaymentHistory.vue